export enum OS {
    android, iOS, unknow
}

export function getMobileOperatingSystem() {
    // @ts-ignore
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    /*if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }*/

    if (/android/i.test(userAgent)) {
        return OS.android;
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return OS.iOS;
    }

    return OS.unknow;
}
